import React, {useRef, useState, useEffect} from 'react';
import styles from './Disclaimer.module.scss'
import DownCarats from "components/icons/downCarats/DownCarats";
import {buttonClick} from "utils/Helpers";

const Disclaimer = (props) => {

    const [disclaimerOpen, setDisclaimerOpen] = useState(true);
    const disclaimer = useRef();

    function toggleDisclaimer(){
        setDisclaimerOpen(!disclaimerOpen);
    }

    useEffect(()=>{
        setTimeout(()=>{
            if(disclaimer.current) setDisclaimerOpen(false)
        }, 4000);
    }, [])

    return (
        <div ref={disclaimer} className={`${styles.disclaimer} ${disclaimerOpen ? styles.open : ''}`}>
                        <span tabIndex={0} role={'button'} aria-label={'Expand disclaimer'} className={styles.expand} onKeyDown={buttonClick} onClick={toggleDisclaimer}>
                            <DownCarats/>
                        </span>
            NO PURCHASE NECESSARY. INTERNET CONNECTION/INSTAGRAM™ OR TIKTOK™ NECESSARY. Starts 12:01 am PT on 6/1/21 & ends 11:59 pm PT on 7/31/21.  Open to legal residents of 50 US & DC 18 +. See <a href={'/contest.pdf'} target={'_blank'} rel="noreferrer">Official Rules</a> for complete details. Void where prohibited. Sponsor: Microsoft Corporation, One Microsoft Way, Redmond, WA 98052.

        </div>
    )
};

export default Disclaimer
